export default function Footer() {
  return (
    <footer className="bg-primary-800 text-background-50 py-12 md:py-16 px-4 md:px-8 lg:px-12 relative overflow-hidden">
      {/* Diagonal decoration overlay */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-primary-700/30 transform skew-x-12 translate-x-20" />
        <div className="absolute top-0 right-0 w-1/3 h-full bg-primary-600/20 transform skew-x-12 translate-x-40" />
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="grid md:grid-cols-3 gap-10 md:gap-8 items-start">
          {/* Brand + Description */}
          <div>
            <img
              src="https://storage.helloreaddy.io/project_files/7ab0d457-3dab-428f-ba9a-e3f3097fe185/9291d9ab-10da-42a6-b94f-73112785d5bd_compressed_Diseo-sin-ttulo-3.webp"
              alt="SERIN Ingeniería de Proyectos SAS"
              className="h-[4.7rem] md:h-[5.5rem] w-auto object-contain mb-4"
            />
            <p className="text-sm text-background-200/80 leading-relaxed mb-5 max-w-xs">
              Soluciones profesionales en climatización, refrigeración y ventilación mecánica.
              Diseñamos, instalamos y mantenemos sistemas eficientes para empresas y proyectos
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.facebook.com/profile.php?id=61585515711369"
                className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-accent-500 transition-colors"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-background-50 text-sm" />
              </a>
              <a
                href="https://www.instagram.com/airesacondicionados.serin"
                className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-accent-500 transition-colors"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-background-50 text-sm" />
              </a>
              <a
                href="https://wa.link/b002hg"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-accent-500 transition-colors"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-background-50 text-sm" />
              </a>
            </div>
          </div>

          {/* Menú */}
          <div className="md:text-center">
            <h4 className="font-heading font-bold text-background-50 text-sm mb-4">
              Menú
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: "Inicio", href: "#inicio" },
                { label: "Nosotros", href: "#nosotros" },
                { label: "Servicios", href: "#servicios" },
                { label: "Contacto", href: "#contacto" },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="text-sm text-background-200/80 hover:text-accent-300 transition-colors"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="font-heading font-bold text-background-50 text-sm mb-4">
              Contacto
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2.5">
                <i className="ri-map-pin-line text-accent-400 text-sm" />
                <span className="text-sm text-background-200/80">
                  Bogotá D.C. - Colombia
                </span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-phone-line text-accent-400 text-sm" />
                <a
                  href="https://wa.link/b002hg"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-background-200/80 hover:text-accent-300 transition-colors"
                >
                  3232209100 - 3505888898
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-mail-line text-accent-400 text-sm" />
                <a
                  href="mailto:ventas@serin.com.co"
                  className="text-sm text-background-200/80 hover:text-accent-300 transition-colors break-all"
                >
                  ventas@serin.com.co - ingenieria@serin.com.co
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 mt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-300/60">
            SERIN Ingeniería de Proyectos SAS © {new Date().getFullYear()}. Todos
            los derechos reservados.
          </p>
          <p className="text-xs text-background-300/60">
            Bogotá D.C. - Colombia | Servicio nacional
          </p>
        </div>
      </div>
    </footer>
  );
}